module.exports = __webpack_public_path__ + "static/media/gloves_800_500.7baf9bac.jpg";